export const ESCAPE_BTN_KEY_CODE = 27
